import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'farm',
    component: () => import('../views/Farm.vue'),
    props:true
  },
  {
    path: '/games',
    name: 'games',
    component: () => import('../views/Games.vue')
  },
  {
    path: '/games/lottery',
    name: 'lottery',
    props: true,
    component: () => import('../views/Lottery.vue')
  },
  {
    path: '/gamedata',
    name: 'gamedata',
    component: () => import('../views/GameData.vue')
  },
  {
    path: '/whitepaper',
    name: 'whitepaper',
    component: () => import('../views/WhitePaper.vue')
  },
  {
    path: '/minting',
    name: 'minting',
    component: () => import('../views/Minting.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
